import { render, staticRenderFns } from "./CompetitionAdminApproved.vue?vue&type=template&id=2eee4146&scoped=true"
import script from "./CompetitionAdminApproved.vue?vue&type=script&lang=js"
export * from "./CompetitionAdminApproved.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAdminApproved.vue?vue&type=style&index=0&id=2eee4146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee4146",
  null
  
)

export default component.exports